export const filterObjectKeys = (obj, string) => {
  const filteredEntries = Object.entries(obj || {}).filter(([key]) => key.startsWith(string));
	
  const filteredObject = Object.fromEntries(filteredEntries);
	
  return filteredObject;
};